// extracted by mini-css-extract-plugin
export var linkText = "_q1-0";